import React from 'react';
import { Hero } from './components/sections/Hero';
import { BeforeAfterSection } from './components/sections/BeforeAfterSection';
import { OpeningHook } from './components/sections/OpeningHook';
import { ProblemSection } from './components/sections/ProblemSection';
import { WhyFailedSection } from './components/sections/WhyFailedSection';
import { MechanismSection } from './components/sections/MechanismSection';
import { WhatYouGet } from './components/sections/WhatYouGet';
import { BonusStackSection } from './components/sections/BonusStackSection';
import { AudienceFit } from './components/sections/AudienceFit';
import { HowItWorks } from './components/sections/HowItWorks';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { ProofSection } from './components/sections/ProofSection';
import { FaqSection } from './components/sections/FaqSection';
import { OfferSection } from './components/sections/OfferSection';
import { UrgencySection } from './components/sections/UrgencySection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0a0e1a] text-white selection:bg-[#c9a84c] selection:text-[#0a0e1a]" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <BeforeAfterSection data-id="element-3" />
        <OpeningHook data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <WhyFailedSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <BonusStackSection data-id="element-9" />
        <AudienceFit data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <GuaranteeSection data-id="element-13" />
        <ProofSection data-id="element-14" />
        <FaqSection data-id="element-15" />
        <OfferSection data-id="element-16" />
        <UrgencySection data-id="element-17" />
        <FinalCtaSection data-id="element-18" />
      </main>
      <Footer data-id="element-19" />
    </div>;
}